import { render, staticRenderFns } from "./ClusterProviderList.vue?vue&type=template&id=0f641bae"
import script from "./ClusterProviderList.vue?vue&type=script&lang=js"
export * from "./ClusterProviderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports